import { closeSubmenus } from './menu'

const initSearchBar = () => {
    const openSearchBars = document.querySelectorAll('.searchbar-js-open')
    const closeSearchBar = document.querySelector('.searchbar-js-close')
    const searchBar = document.querySelector('.searchbar-js')

    openSearchBars.forEach(btn => {
        btn.addEventListener('click', (e) => {
            searchBar.classList.toggle('opened')
            e.currentTarget.classList.toggle('active')
            closeSubmenus()
        })
    })

    closeSearchBar.addEventListener('click', () => {
        searchBar.classList.remove('opened')
        openSearchBars.forEach(btn => btn.classList.remove('active'))
    })
}

export { initSearchBar }